import { functions } from '../../constants/firebase';
import { connect } from 'react-redux';
import CompleteOrderComponent from './CompleteOrderComponent';
import { blockUi, showAlert } from '../../actions';
import { httpsCallable } from 'firebase/functions';

const getOrderInfo = async (dispatch, id) => {

  dispatch(blockUi(true));

  try {

    const completeOrder = httpsCallable(functions, 'completeOrder');
    const res = await completeOrder({ id });

    if (res.data.error) {
      dispatch(showAlert('danger', res.data.error));
    } else {
      dispatch(showAlert('success', 'The order has been marked complete. You can close this page.'));
    }

  } catch (e) {

    console.error(e);
    dispatch(showAlert('danger', e.message));
    
  }

  dispatch(blockUi(false));

}

const mapDispatchToProps = (dispatch, props) => ({
  completeOrder: () => getOrderInfo(dispatch, props.match.params.id)
});

export default connect(
  null,
  mapDispatchToProps
)(CompleteOrderComponent);